import emitter from "@webcore/core/events/eventemitter.ts";
import * as Sentry from "@sentry/react";

if (!import.meta.env.DEV) {
  Sentry.init({
    dsn: "https://133f98834ee36a0bdefce1f4ccc3af15@o1388406.ingest.us.sentry.io/4509608376926208",
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
  });
}

emitter.on("ui-ready", () => {
  import("./main.app");  
})

emitter.on("initialized", () => {
    emitter.emit("load");
});

import("./app");


